import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Tag } from 'antd'
import { stylesIf, themeColor } from 'utils/styles'

const { CheckableTag } = Tag

const ChipTagMenu = ({ value, options, onChange, className }) => {
  const computeOptions = options.map((option) => {
    if (
      (value.includes && value.includes(option.value)) ||
      value === option.value
    ) {
      return {
        ...option,
        checked: true,
      }
    }
    return {
      ...option,
      checked: false,
    }
  })

  const handleOnChange = (option) => {
    const { checked, value: optVal } = option

    if (checked) {
      // remove from value
      const nextValue = value.filter((v) => v !== optVal)
      onChange(nextValue)
    } else {
      // add to value
      const nextValue = [...value, optVal]
      onChange(nextValue)
    }
  }

  return (
    <Tags className={className}>
      {computeOptions.map((option) => {
        const { key, title, value: optVal, checked } = option
        return (
          <StyledCheckableTag
            key={key || optVal}
            onChange={() => handleOnChange(option)}
            checked={checked}
          >
            {title || optVal}
          </StyledCheckableTag>
        )
      })}
    </Tags>
  )
}

ChipTagMenu.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      title: PropTypes.string,
      value: PropTypes.node,
    })
  ),
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.number),
  ]),
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.number),
  ]),
}

ChipTagMenu.defaultProps = {
  className: '',
  options: [],
  value: [],
}

export default ChipTagMenu

const Tags = styled.div(
  (props) => `
  box-sizing: border-box;
  background-color: ${themeColor('whitePrimary', props)};
  border-radius: 4px;
  outline: none;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 3px;
  padding: 3px 4px;
  border-radius: 3px;
  border: solid 1px ${themeColor('grey', props)};
  flex-wrap: wrap;
`
)

const StyledCheckableTag = styled(CheckableTag)((props) => {
  const { checked } = props
  const activeStyles = stylesIf(
    checked,
    `
    background: ${themeColor('blueSecondary', props)};
    border: 1px solid ${themeColor('blueSecondary', props)};
    color: white;
    &:after {
      content: " \x00d7";
    }
    `
  )
  const inactiveStyles = stylesIf(
    !checked,
    `
    background: ${themeColor('dark')};
    border: 1px solid gray;
    color: gray !important;
    &:after {
      content: ' +';
    }
    `
  )

  return `
    padding: 2px 6px;
    border-radius: 4px;
    margin: 0;
    cursor: pointer;
    font-size: 12px;
    &:first-of-type {
      margin-left: 0;
    }
    &:after {
      position: relative;
      top: 1px;
      margin-left: 3px;
    }
    ${activeStyles}
    ${inactiveStyles}
  `
})
